import { SET_HAS_EDUCATION } from '../actions/hasEducationDataActions';

let initialState = false;

const hasEducationDataReducer = (state = initialState, action) => {
    switch (action.type) {
        case SET_HAS_EDUCATION:
            return action.payload.value
        default:
            return state;
    }
}

export default hasEducationDataReducer;